<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <span @click="rootDir = null">Topics</span>
      </div>
    </div>
    <div class="card-content">
      <document-categories :topics="topics" @select="selectTopic"></document-categories>
    </div>
  </div>
</template>

<script>
import DocumentCategories from './components/DocumentCategoriesComponent.vue';

export default {
  data() {
    return {
      topics: [    
        'HAWK u8',
        'OSPREY u8',
        'GOSHAWK u8',
        'PEREGRINE u8',
        'CONNECTIVITY SERVICES',
        'MARKETING AND SALES ASSETS',
        'LOGISTICS, IMPORT, AND REGISTRATION',
        'ACCESS PORTAL AND APP',
        'u7 PRODUCTS AND ACCESSORIES',
      ]
    }
  },
  components: { DocumentCategories },
  methods: {
    selectTopic(topic) {  
      // navigate user to topic
      this.$router.push({ 
        name: 'documentationTopic', 
        query: { rootDir: `/documents/${topic}` }
      });
    }
  },
  computed: {
    documents() {
      return this.$store.state.storage.documents;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
